import { differenceInCalendarDays, parseISO, isValid } from "date-fns";

export function nightsBetween(checkin, checkout) {
  if (!checkin || !checkout) return 0;
  const a = parseISO(checkin);
  const b = parseISO(checkout);
  if (!isValid(a) || !isValid(b)) return 0;
  return Math.max(0, differenceInCalendarDays(b, a));
}

export function todayISO() {
  return new Date().toISOString().split("T")[0];
}

// Validazione date/ospiti — messaggi in italiano
export function validateSearch({ checkin, checkout, adults = 1, maxGuests }) {
  const errors = {};
  const today = todayISO();
  if (checkin && checkin < today) errors.checkin = "La data di check-in non può essere nel passato.";
  if (checkin && checkout) {
    if (checkout <= checkin) errors.checkout = "Il check-out deve essere successivo al check-in.";
  }
  if (adults < 1) errors.adults = "È richiesto almeno un adulto.";
  if (maxGuests && adults && adults > maxGuests) errors.adults = `Questa struttura ospita al massimo ${maxGuests} persone.`;
  return errors;
}

export function formatEUR(value) {
  return new Intl.NumberFormat("it-IT", { style: "currency", currency: "EUR", maximumFractionDigits: 0 }).format(value || 0);
}
